import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=1634c273&"
import script from "./Section.vue?vue&type=script&lang=ts&"
export * from "./Section.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1634c273')) {
      api.createRecord('1634c273', component.options)
    } else {
      api.reload('1634c273', component.options)
    }
    module.hot.accept("./Section.vue?vue&type=template&id=1634c273&", function () {
      api.rerender('1634c273', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/text/Section.vue"
export default component.exports